/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigMBWBDetailsResponseResponse,
  BboBranchConfigUnauthorizedResponse,
  BboBranchConfiggetMBWBDetailsParams,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get MB/WB history for a branch
 */
export const bboBranchConfiggetMBWBDetails = (
  params?: BboBranchConfiggetMBWBDetailsParams,
  signal?: AbortSignal,
) => {
  return customInstance<BboBranchConfigMBWBDetailsResponseResponse>({
    url: `/BboBranchConfigService/v1/GetMBWBDetails`,
    method: 'get',
    params,
    signal,
  });
};

export const getBboBranchConfiggetMBWBDetailsQueryKey = (
  params?: BboBranchConfiggetMBWBDetailsParams,
) => {
  return [`/BboBranchConfigService/v1/GetMBWBDetails`, ...(params ? [params] : [])] as const;
};

export const getBboBranchConfiggetMBWBDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof bboBranchConfiggetMBWBDetails>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  params?: BboBranchConfiggetMBWBDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bboBranchConfiggetMBWBDetails>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBboBranchConfiggetMBWBDetailsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bboBranchConfiggetMBWBDetails>>> = ({
    signal,
  }) => bboBranchConfiggetMBWBDetails(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bboBranchConfiggetMBWBDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BboBranchConfiggetMBWBDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof bboBranchConfiggetMBWBDetails>>
>;
export type BboBranchConfiggetMBWBDetailsQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Get MB/WB history for a branch
 */
export const useBboBranchConfiggetMBWBDetails = <
  TData = Awaited<ReturnType<typeof bboBranchConfiggetMBWBDetails>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  params?: BboBranchConfiggetMBWBDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof bboBranchConfiggetMBWBDetails>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBboBranchConfiggetMBWBDetailsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
